// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"_loading_component_skeleton_3i8qI","skeleton-blink":"_loading_component_skeleton-blink_3QjeU","skeleton__row":"_loading_component_skeleton__row_RjV7s"};